import DataMapper from './../DataMapper'
// import CaseServiceDataRM from '../../responsemodel/CaseServiceDataRM'
// import CaseServiceData from '../../../models/CaseServiceData'
import AttendentInfoData from '../../../models/CaseServiceData/AttendentInfoData'
import AttendentInfoDataRM from '../../responsemodel/CaseServiceDataRM/AttendentInfoDataRM'
class AttendentInfoDataMapper extends DataMapper<AttendentInfoDataRM, AttendentInfoData> {
    map = (rm: AttendentInfoDataRM) => new AttendentInfoData(rm.alternativePhone, rm.contactNumber, rm.email, rm.hospitalData, rm.investigatorName, rm.isFieldSaved, rm.occupation, rm.occupationAddress, rm.occupationId, rm.relationWithInsured, rm.supportingDocuments)
}
export default AttendentInfoDataMapper
